var map = {
	"./Ace@10.jpg": 431,
	"./Ace@10_a.jpg": 1115,
	"./Ace@10_b.jpg": 6460,
	"./Ace@10_c.jpg": 3337,
	"./Ace@10_d.jpg": 6618,
	"./Ace@10_e.jpg": 4359,
	"./Ace@10_f.jpg": 8024,
	"./Afe.png": 6441,
	"./Ayodeji Adegoke.jpg": 4090,
	"./Banke Ogunlana Passport.jpg": 8997,
	"./Capicace-logo.png": 4216,
	"./Cognitive CloudRAN.png": 593,
	"./Container-image.jpg": 2342,
	"./Container-image.png": 2882,
	"./Cubre.png": 1142,
	"./DR.OLABODE-IDOWU.jpeg": 2637,
	"./Dr Osin.jpg": 554,
	"./Dr-Raymond.jpg": 5388,
	"./Dr-Thakur1.jpeg": 3413,
	"./Dr_Abdultaofeek Abayomi.jpg": 6361,
	"./Dr_Badejo.jpeg": 1046,
	"./Dr_ayokunle.jpeg": 4615,
	"./EDGE-AI.png": 2201,
	"./Edge.png": 1660,
	"./FEDGEN Datahub.png": 2935,
	"./FEDGEN-Codinghub.png": 5834,
	"./FEDSEC.png": 2415,
	"./Fedgen-HealthEduApp.jpeg": 4603,
	"./Fegden-monitor.png": 2881,
	"./Home-image.png": 8970,
	"./Monthly-Research-August.jpg": 4460,
	"./NIH.png": 9602,
	"./Obiyemi Obiseye.jpg": 7613,
	"./Takenga Claude Mbusa.png": 6144,
	"./World-bank-logo.png": 2954,
	"./aspmir-logo.png": 291,
	"./capic-logo.png": 5435,
	"./cea-logo.png": 6016,
	"./computeEngine.png": 5870,
	"./covenant-logo.png": 363,
	"./database.png": 7644,
	"./dr-adeshina.jpg": 3553,
	"./dr-ejidokun.jpeg": 7690,
	"./dr-funmilayo-sijuade.jpeg": 6841,
	"./dr-popoola.jpeg": 9369,
	"./dr-temitope-oluwatosin.jpeg": 7078,
	"./dstn-logo.png": 5064,
	"./fedgen-logo.png": 5968,
	"./gb.png": 9748,
	"./google-logo.png": 5616,
	"./group1.png": 641,
	"./group2.jpeg": 171,
	"./group3.png": 2419,
	"./group4.jpeg": 6257,
	"./group5.jpeg": 986,
	"./group6.jpeg": 1543,
	"./group7.jpg": 8967,
	"./innia-logo.png": 6334,
	"./landmark-logo.png": 3859,
	"./microchip.png": 2001,
	"./oafd-logo.png": 5105,
	"./object_store.png": 6568,
	"./prof-dame-diong.jpeg": 4569,
	"./prof-maissa-mbaye.jpeg": 3641,
	"./prof-subusiso-moyo.jpeg": 7320,
	"./server.png": 6194,
	"./ugb-logo.png": 4809,
	"./ulpgl.png": 4171
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3907;